import ilComponent from './RelationSearch'

export default Vue => {
    Vue.component(ilComponent.name, ilComponent);
}
